import React, { ReactElement } from 'react';
import { Image } from 'react-bootstrap';
import { GiftMessage } from '../../models/giftMessage';
import './GiftCombo.scss';
import comboBg from '../../../../assets/svg/combo/BG.svg';
import combo0 from '../../../../assets/svg/combo/0.svg';
import combo1 from '../../../../assets/svg/combo/1.svg';
import combo2 from '../../../../assets/svg/combo/2.svg';
import combo3 from '../../../../assets/svg/combo/3.svg';
import combo4 from '../../../../assets/svg/combo/4.svg';
import combo5 from '../../../../assets/svg/combo/5.svg';
import combo6 from '../../../../assets/svg/combo/6.svg';
import combo7 from '../../../../assets/svg/combo/7.svg';
import combo8 from '../../../../assets/svg/combo/8.svg';
import combo9 from '../../../../assets/svg/combo/9.svg';
import { useEffect } from 'react';
import { numberToDigital } from '../../../../common/utils/utils';

interface GiftComboProps {
  gift: GiftMessage;
  onFinish: (loginId: string | undefined) => void;
}

export const GiftComboCount = (props: GiftComboProps): ReactElement => {
  const getComboAssetByNumber = (combo: number): string => {
    switch (combo) {
      case 0:
        return combo0;
      case 1:
        return combo1;
      case 2:
        return combo2;
      case 3:
        return combo3;
      case 4:
        return combo4;
      case 5:
        return combo5;
      case 6:
        return combo6;
      case 7:
        return combo7;
      case 8:
        return combo8;
      case 9:
        return combo9;
      default:
        return '';
    }
  };

  useEffect(() => {
    setTimeout(() => {
      props.onFinish(props.gift.sender?.loginId);
    }, 200);
  }, []);

  return (
    <>
      {/* Combo count */}
      <div className="gift-combo__count">
        {numberToDigital(props.gift.combo?.count).map((value, index) => {
          return (
            <Image
              key={`${index}-${value}`}
              src={getComboAssetByNumber(value)}
              className="gift-combo__count-digital"
            ></Image>
          );
        })}
      </div>
    </>
  );
};

export const GiftCombo = (props: GiftComboProps): ReactElement => {
  return (
    <div className="gift-combo__container">
      {/* Combo icon */}
      <Image
        src={props.gift.giftType?.icon?.uri}
        className="gift-combo__icon"
      ></Image>

      {/* Combo name */}
      <p className="gift-combo__name">{props.gift.sender?.loginId}</p>

      <GiftComboCount
        {...props}
        key={`${numberToDigital(props.gift.combo?.count).join()}`}
      ></GiftComboCount>

      {/* Background */}
      <Image src={comboBg} className="gift-combo__bg"></Image>
    </div>
  );
};
